"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReferralSaleContract = exports.TimelineStatus = void 0;
var react_1 = require("react");
var abi_1 = require("../abi");
var TimelineStatus;
(function (TimelineStatus) {
    TimelineStatus[TimelineStatus["PreRegister"] = 0] = "PreRegister";
    TimelineStatus[TimelineStatus["Register"] = 1] = "Register";
    TimelineStatus[TimelineStatus["Prepare"] = 2] = "Prepare";
    TimelineStatus[TimelineStatus["Live"] = 3] = "Live";
    TimelineStatus[TimelineStatus["Fcfs"] = 4] = "Fcfs";
    TimelineStatus[TimelineStatus["Ended"] = 5] = "Ended";
})(TimelineStatus = exports.TimelineStatus || (exports.TimelineStatus = {}));
function useReferralSaleContract(config, web3) {
    return (0, react_1.useMemo)(function () {
        if (!web3 || !config.sale.address)
            return undefined;
        return new web3.eth.Contract(abi_1.CONTRACTS.referralSale['v1'].abi, config.sale.address);
    }, [web3, config.sale.address]);
}
exports.useReferralSaleContract = useReferralSaleContract;
